export const getRawPercentage = (count: number, total: number): number => total > 0 ? (count / total) * 100 : 0;

export const getChangePercentage = (currentCount: number, previousCount: number): number => getRawPercentage(currentCount - previousCount, previousCount);
